var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: Boolean(_vm.action),
              expression: "Boolean(action)"
            }
          ],
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "grid-style": "min-width: 220px;width:100%;height:100%;",
                  "min-height": "100%",
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        { ref: "cargoButtonGroupSlider" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "look",
                                  expression: "action==='look'"
                                }
                              ],
                              class:
                                "btn-group-look" +
                                (_vm.canOperateJob ? "" : " cannot-operate-job")
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "can-operate",
                                  attrs: { no: "1", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.backEventFlag = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "2",
                                    disabled: !(
                                      _vm.job &&
                                      Number(_vm.job.jobState) === 0 &&
                                      !_vm.JobUtils.isBlockJob(_vm.job)
                                    ),
                                    type: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editEventFlag = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_SIBooking_addSIBooking"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_SIBooking_addSIBooking'])"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "3",
                                    disabled: _vm.hqDisabledOperate,
                                    type: "primary"
                                  },
                                  on: { click: _vm.addHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_SIBooking_addSIBooking"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_SIBooking_addSIBooking'])"
                                    }
                                  ],
                                  attrs: { no: "4", type: "primary" },
                                  on: { click: _vm.toCopy }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "5", type: "success" },
                                  on: { click: _vm.onPrint }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.$checkPermission([
                                          "button_JobBooking_ReturnReview"
                                        ]) && _vm.showReturnReview,
                                      expression:
                                        "$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                                    }
                                  ],
                                  attrs: {
                                    no: "returnReview",
                                    type: "primary"
                                  },
                                  on: { click: _vm.returnReview }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ReturnPreApprovalRemoteBooking"
                                      )
                                    )
                                  )
                                ]
                              ),
                              (_vm.job.shutOut
                              ? _vm.btnInfo.privilege
                                  .button_SIBooking_cancelShutout
                              : _vm.btnInfo.privilege.button_SIBooking_Shutout)
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "6",
                                        type: "primary",
                                        disabled:
                                          !(
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.OPERATING ||
                                            _vm.job.jobState ===
                                              _vm.SystemConstants.SHUT_OUT
                                          ) || _vm.isCooperate
                                      },
                                      on: { click: _vm.toShutOut }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.btnInfo.label.shutOutLabel)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.btnInfo.visible.printFclProfit,
                                      expression:
                                        "btnInfo.visible.printFclProfit"
                                    }
                                  ],
                                  attrs: {
                                    no: "7",
                                    disabled: !_vm.btnInfo.enabled
                                      .printFclProfit,
                                    type: "primary"
                                  },
                                  on: { click: _vm.printFCLPROFIT }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PrintFclProfit"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.btnInfo.visible.printLclProfit,
                                      expression:
                                        "btnInfo.visible.printLclProfit"
                                    }
                                  ],
                                  attrs: {
                                    no: "8",
                                    disabled: !_vm.btnInfo.enabled
                                      .printLclProfit,
                                    type: "primary"
                                  },
                                  on: { click: _vm.printLCLPROFIT }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PrintLclProfit"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  class:
                                    _vm.btnInfo.label.btnEntrustment ===
                                    _vm.$t(
                                      "SeaExport.AssociationBusinessInformation"
                                    )
                                      ? "can-operate"
                                      : "",
                                  attrs: {
                                    no: "btnEntrustment",
                                    type: "primary",
                                    disabled: !(
                                      (_vm.btnInfo.privilege
                                        .consignationEnable &&
                                        _vm.$store.getters.isGroupCompany) ||
                                      _vm.btnInfo.privilege
                                        .consignationCrossEnable
                                    )
                                  },
                                  on: { click: _vm.entrustmentClickHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.btnInfo.label.btnEntrustment)
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.btnInfo.visible.btnPreSubmit,
                                      expression: "btnInfo.visible.btnPreSubmit"
                                    }
                                  ],
                                  attrs: {
                                    no: "9",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmitPrint_PreSubmit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PreSubmission"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.btnInfo.visible.btnSubmit,
                                      expression: "btnInfo.visible.btnSubmit"
                                    }
                                  ],
                                  attrs: {
                                    no: "10",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmitPrint_Submit }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Submission")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.btnInfo.visible.btnManagerSubmit,
                                      expression:
                                        "btnInfo.visible.btnManagerSubmit"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "11",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmitPrint_ManagerSubmit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ManagerSubmission")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.btnInfo.visible
                                          .btnManagerAuditSubmit,
                                      expression:
                                        "btnInfo.visible.btnManagerAuditSubmit"
                                    }
                                  ],
                                  attrs: {
                                    no: "12",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmitAudit_ManagerSubmit }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Audit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.btnInfo.visible.printReturnOperate,
                                      expression:
                                        "btnInfo.visible.printReturnOperate"
                                    }
                                  ],
                                  attrs: {
                                    no: "13",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.backReturn }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ReturnAction"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.btnInfo.visible.printReturn,
                                      expression: "btnInfo.visible.printReturn"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "14",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.backReturn }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PrintReturn"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        (!_vm.orderCenterBranch ||
                                          (_vm.orderCenterBranch &&
                                            _vm.useOrderCenterBranch &&
                                            !_vm.isRegionalCommission)),
                                      expression:
                                        "useOrderCenterMode && !masterFlag && (!orderCenterBranch || (orderCenterBranch && useOrderCenterBranch) && !isRegionalCommission)"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperation",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Cooperation"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        !_vm.orderCenterBranch,
                                      expression:
                                        "useOrderCenterMode && !masterFlag && !orderCenterBranch"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperationReturn",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationReturnHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CooperationReturn")
                                    )
                                  )
                                ]
                              ),
                              _vm.job.trustFromJob
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "can-operate",
                                      attrs: {
                                        no: "15",
                                        type: "primary",
                                        disabled: !_vm.job.trustFromJob
                                      },
                                      on: { click: _vm.querySEtrustFrom }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.AssociationBusinessInformation"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.job.trustFromJob,
                                      expression: "job.trustFromJob"
                                    }
                                  ],
                                  attrs: {
                                    no: "16",
                                    disabled:
                                      _vm.job.jobState !==
                                      _vm.SystemConstants.STATE_OPERATING.code,
                                    type: "primary"
                                  },
                                  on: { click: _vm.syncTrustFromJob }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.SynchronizationInformation"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.job.jobState ===
                                          _vm.SystemConstants.VERIFIED &&
                                        _vm.job.changeState ===
                                          _vm.SystemConstants.VERIFIED &&
                                        _vm.$checkPermission([
                                          "button_JobBooking_ChangeCommit"
                                        ]) &&
                                        Number(
                                          _vm.config.get(
                                            "IsCommittedAllowAddCost"
                                          )
                                        ) === 1,
                                      expression:
                                        "job.jobState === SystemConstants.VERIFIED && job.changeState === SystemConstants.VERIFIED && $checkPermission(['button_JobBooking_ChangeCommit']) && Number(config.get('IsCommittedAllowAddCost')) === 1"
                                    }
                                  ],
                                  attrs: { no: "17", type: "primary" },
                                  on: { click: _vm.changeCommit_clickHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ChangeCommit"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.btnInfo.visible
                                          .sendBackBookingButton &&
                                        _vm.$checkPermission([
                                          "button_SEBooking_sendBackBooking"
                                        ]),
                                      expression:
                                        "btnInfo.visible.sendBackBookingButton && $checkPermission(['button_SEBooking_sendBackBooking'])"
                                    }
                                  ],
                                  attrs: { no: "18", type: "primary" },
                                  on: { click: _vm.sendBookingData }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.SendBookingData"))
                                  )
                                ]
                              ),
                              _c(
                                "el-badge",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    "is-dot": _vm.crossTenantDialog.readState
                                  }
                                },
                                [
                                  _c(
                                    "el-dropdown",
                                    {
                                      staticClass: "can-operate",
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: {
                                        no: "19",
                                        "split-button": "",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.logHandle()
                                        },
                                        command: function(p) {
                                          _vm.logCommand = p
                                          _vm.logHandle()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_LogRecord")
                                        ) + " "
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.QueryContainerInfo"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.QueryContainerInfo"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "CargoMsg.Cargo_BusinessStatusChangeLog"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_BusinessStatusChangeLog"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-badge",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "is-dot":
                                                  _vm.crossTenantDialog
                                                    .readState
                                              }
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    disabled: !_vm.job
                                                      .trustFromJob,
                                                    command: _vm.$t(
                                                      "SeaExport.ChangeHistory"
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SeaExport.ChangeHistory"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "SeaExport.OperationLog"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.OperationLog"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-menu",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.combinedManifest,
                                      expression: "combinedManifest"
                                    }
                                  ],
                                  staticClass:
                                    "el-menu-button el-button el-button--primary el-button--mini",
                                  staticStyle: {
                                    width: "90px",
                                    "vertical-align": "top"
                                  },
                                  attrs: {
                                    "text-color": "#404144",
                                    "active-text-color": "#404144",
                                    mode: "horizontal"
                                  },
                                  on: { select: _vm.toBooking }
                                },
                                [
                                  _c(
                                    "el-submenu",
                                    {
                                      attrs: {
                                        index: "index",
                                        disabled: _vm.bookingBtn
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "el-menu-btn-text",
                                          attrs: { slot: "title" },
                                          slot: "title"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.EDIBooking")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-submenu",
                                        { attrs: { index: "original" } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.Original")
                                              )
                                            )
                                          ]),
                                          _c(
                                            "el-menu-item",
                                            {
                                              attrs: {
                                                index: "API0",
                                                disabled: !_vm.bookingEDIApiOpen
                                              }
                                            },
                                            [_vm._v("API")]
                                          ),
                                          _c(
                                            "el-menu-item",
                                            { attrs: { index: "FTP1" } },
                                            [_vm._v("FTP")]
                                          )
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-submenu",
                                        { attrs: { index: "correct" } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.Correct")
                                              )
                                            )
                                          ]),
                                          _c(
                                            "el-menu-item",
                                            { attrs: { index: "FTP0" } },
                                            [_vm._v("FTP")]
                                          ),
                                          _c(
                                            "el-menu-item",
                                            {
                                              attrs: {
                                                index: "API1",
                                                disabled: !_vm.bookingEDIApiOpen
                                              }
                                            },
                                            [_vm._v("API")]
                                          )
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-submenu",
                                        { attrs: { index: "shutOut" } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.ShutOut")
                                              )
                                            )
                                          ]),
                                          _c(
                                            "el-menu-item",
                                            { attrs: { index: "FTP2" } },
                                            [_vm._v("FTP")]
                                          ),
                                          _c(
                                            "el-menu-item",
                                            {
                                              attrs: {
                                                index: "API2",
                                                disabled: true
                                              }
                                            },
                                            [_vm._v("API")]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "edit",
                                  expression: "action==='edit'"
                                }
                              ],
                              staticClass: "btn-group-edit",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "20",
                                    type: "success",
                                    disabled: _vm.context.loading
                                  },
                                  on: { click: _vm.triggerSaveEvent }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "21", type: "success" },
                                  on: {
                                    click: function($event) {
                                      _vm.cancelEdit(
                                        _vm.openMultiple
                                          ? _vm.againLookAtMultiple
                                          : function() {
                                              _vm.againShow("look")
                                            }
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "22", type: "primary" },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isNew,
                                  expression: "isNew"
                                }
                              ],
                              staticClass: "btn-group-new",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "23",
                                    type: "success",
                                    disabled: _vm.context.loading
                                  },
                                  on: { click: _vm.triggerSaveEvent }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "24", type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelEdit(
                                        _vm.openMultiple
                                          ? _vm.goBackAtMultiple
                                          : _vm.goBack
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "25", type: "primary" },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            "white-space": "nowrap",
                            display: "flex"
                          }
                        },
                        [
                          _c("CargoIm", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imCacheKey && _vm.action === "look",
                                expression: "imCacheKey && action==='look'"
                              }
                            ],
                            ref: "cargoIm"
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "red"
                              },
                              attrs: { no: "SopState" }
                            },
                            [_vm._v(_vm._s(_vm.commonInfo.jobState))]
                          ),
                          _vm.job.payableChargeLockedStatus === 1
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "red",
                                    "padding-left": "9px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_PayableLockedStatusTag"
                                      )
                                    )
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.payableChargeLockedTooltip,
                                        placement: "bottom",
                                        "visible-arrow": false
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning",
                                        staticStyle: { cursor: "pointer" }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: {
                                  "font-size": "12px",
                                  padding: "7px 9px",
                                  color: "unset"
                                },
                                attrs: { no: "26", type: "text" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.onBtnListDoubleClicked()
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: { "font-size": "12px", color: "red" }
                            },
                            [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                          ),
                          _vm.commonInfo.provisionLock &&
                          _vm.commonInfo.provisionLock.etdLocked
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "red",
                                    "margin-left": "10px"
                                  }
                                },
                                [_vm._v("计提已校准")]
                              )
                            : _vm._e(),
                          _vm.job.zyCreditWarning
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.job.zyCreditWarning,
                                    placement: "bottom-start",
                                    "visible-arrow": false
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-tip",
                                      staticStyle: {
                                        cursor: "pointer",
                                        "font-size": "12px",
                                        color: "orange",
                                        width: "250px",
                                        overflow: "hidden",
                                        "text-overflow": "ellipsis",
                                        "white-space": "nowrap"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.job.zyCreditWarning))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  ref: "tabsContainer",
                  class:
                    "tabs-container" +
                    (_vm.canOperateJob ? "" : " cannot-operate-job")
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "basicTab",
                                label: _vm.$t("SeaExport.ImportOperation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("basic-tab-UICustom", {
                                    ref: "basicTab",
                                    attrs: {
                                      "view-source": "bookingWorkspace",
                                      "is-cross-tenant-s-e-to-s-i":
                                        _vm.isCrossTenantSEToSI,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock
                                    },
                                    on: {
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent,
                                      tabNotCheckedCallBack:
                                        _vm.tabNotCheckedCallBack,
                                      updateJob: function($event) {
                                        return _vm.$emit("updateJob")
                                      }
                                    }
                                  })
                                : _c("basic-tab", {
                                    ref: "basicTab",
                                    attrs: {
                                      "view-source": "bookingWorkspace",
                                      "is-cross-tenant-s-e-to-s-i":
                                        _vm.isCrossTenantSEToSI,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock
                                    },
                                    on: {
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent,
                                      tabNotCheckedCallBack:
                                        _vm.tabNotCheckedCallBack,
                                      updateJob: function($event) {
                                        return _vm.$emit("updateJob")
                                      }
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "masterBasicTab",
                                label: _vm.$t("SeaExport.ImportOperation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("master-basic-tab-UICustom", {
                                    ref: "masterBasicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "view-source": "bookingWorkspace",
                                      "is-cross-tenant-s-e-to-s-i":
                                        _vm.isCrossTenantSEToSI,
                                      "show-trucking": _vm.showTrucking,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent,
                                      updateJob: function($event) {
                                        return _vm.$emit("updateJob")
                                      },
                                      verticalScroll: _vm.onVerticalScroll
                                    }
                                  })
                                : _c("master-basic-tab", {
                                    ref: "masterBasicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "view-source": "bookingWorkspace",
                                      "is-cross-tenant-s-e-to-s-i":
                                        _vm.isCrossTenantSEToSI,
                                      "show-trucking": _vm.showTrucking,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob,
                                      containerLoadTypeEvent:
                                        _vm.containerLoadTypeEvent,
                                      updateJob: function($event) {
                                        return _vm.$emit("updateJob")
                                      },
                                      verticalScroll: _vm.onVerticalScroll
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: "tabArrivalInformation",
                          attrs: {
                            lazy: true,
                            name: "tabArrivalInformation",
                            label: _vm.$t("SeaExport.ArrivalInformation")
                          }
                        },
                        [
                          _vm.$store.state.uiCustom.enable
                            ? _c("tab-arrival-information-UICustom", {
                                ref: "tabArrivalInformation",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            : _c("tab-arrival-information", {
                                ref: "tabArrivalInformation",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                        ],
                        1
                      ),
                      !_vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearance",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearance",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance", {
                                ref: "tabUsCustomsClearance",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearanceMaster",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearanceMaster",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance-master", {
                                ref: "tabUsCustomsClearanceMaster",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.masterFlag || _vm.paramsOfTab.signMBL)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabMBL",
                                label: "MB/L"
                              }
                            },
                            [
                              _c("tab-mbl", {
                                ref: "tabMBL",
                                attrs: {
                                  "is-cross-tenant-s-e-to-s-i":
                                    _vm.isCrossTenantSEToSI,
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "view-source": "SiBooking"
                                },
                                on: {
                                  tabNotCheckedCallBack:
                                    _vm.tabNotCheckedCallBack,
                                  resetTab: _vm.resetTab
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.paramsOfTab.typeMBL !== 0 &&
                        _vm.paramsOfTab.typeMBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabMBL2",
                                label:
                                  "MB/L " +
                                  (_vm.paramsOfTab.typeMBL === 2
                                    ? this.$store.getters.language === "zh"
                                      ? "拆单"
                                      : "Split"
                                    : "") +
                                  (_vm.paramsOfTab.typeMBL === 3
                                    ? this.$store.getters.language === "zh"
                                      ? "并单"
                                      : "Merge"
                                    : "")
                              }
                            },
                            [
                              _c("tab-mbl2", {
                                ref: "tabMBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.signHBL &&
                      !_vm.masterFlag &&
                      !_vm.paramsOfTab.mblOnly
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabHBL",
                                label: "HB/L"
                              }
                            },
                            [
                              _c("tab-hbl", {
                                ref: "tabHBL",
                                attrs: {
                                  "is-cross-tenant-s-e-to-s-i":
                                    _vm.isCrossTenantSEToSI,
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "view-source": "SiBooking"
                                },
                                on: {
                                  resetTab: _vm.resetTab,
                                  syncData: _vm.syncData
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.isNew &&
                      _vm.paramsOfTab.typeHBL !== 0 &&
                        _vm.paramsOfTab.typeHBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabHBL2",
                                label:
                                  "HB/L " +
                                  (_vm.paramsOfTab.typeHBL === 2
                                    ? this.$store.getters.language === "zh"
                                      ? "拆单"
                                      : "Split"
                                    : "") +
                                  (_vm.paramsOfTab.typeHBL === 3
                                    ? this.$store.getters.language === "zh"
                                      ? "并单"
                                      : "Merge"
                                    : "")
                              }
                            },
                            [
                              _c("tab-hbl2", {
                                ref: "tabHBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showTrucking
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabLocalService",
                                label: _vm.$t("SeaExport.LocalService")
                              }
                            },
                            [
                              _c("tab-local-service", {
                                ref: "tabLocalService",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit-warehouse":
                                    _vm.cooperateEditWarehouse,
                                  "cooperate-edit-trucking":
                                    _vm.cooperateEditTrucking
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) && _vm.paramsOfTab.insure
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                name: "tabInsure",
                                label: _vm.$t("SeaExport.InsureInfo")
                              }
                            },
                            [
                              _c("tab-insure", {
                                ref: "tabInsure",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 19,
                          attrs: {
                            lazy: true,
                            name: "tabTradeDetail",
                            label: _vm.$t("SeaExport.TradeDetail")
                          }
                        },
                        [
                          _c("tab-trade-detail", {
                            ref: "tabTradeDetail",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "cooperate-edit": _vm.cooperateEditOther
                            },
                            on: { syncData: _vm.syncData }
                          })
                        ],
                        1
                      ),
                      _vm.paramsOfTab.itmService
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                lazy: true,
                                name: "tabTradeCommission",
                                label: _vm.$t("SeaExport.TradeCommission")
                              }
                            },
                            [
                              _c("tab-trade-commission", {
                                ref: "tabTradeCommission",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "view-source": "bookingWorkspace"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabLclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-lcl-container", {
                                ref: "tabLclContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  location: _vm.location
                                },
                                on: {
                                  addSlavedJob: _vm.addSlavedJob,
                                  removeJobFromMaster: _vm.removeJobFromMaster,
                                  split: _vm.splitHandle
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.privilege.charge.chargeView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 21,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-cross-tenant-se-to-si":
                                    _vm.isCrossTenantSEToSI,
                                  location: _vm.location,
                                  "view-source": "SiBooking",
                                  "provision-lock": _vm.commonInfo.provisionLock
                                },
                                on: {
                                  printDataCallBack:
                                    _vm.tabChargesPrintDataCallBack
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 22,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew && _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 23,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location,
                                  "view-source": "SiBooking"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 24,
                              attrs: {
                                lazy: true,
                                name: "tabAdvanceCharge",
                                label: _vm.$t("SeaExport.AdvanceChargeInfo")
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) && _vm.paramsOfTab.customs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 18,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _c("tab-customs-info", {
                                ref: "tabCustomsInfo",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditCustoms
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.importManifest
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 18.5,
                              attrs: {
                                lazy: true,
                                name: "tabImportManifest",
                                label: _vm.$t("SeaImport.ImportManifest")
                              }
                            },
                            [
                              _c("tab-import-manifest", {
                                ref: "tabImportManifest",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 25,
                              attrs: {
                                lazy: true,
                                name: "tabFile",
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.cargoType &&
                      _vm.paramsOfTab.cargoType !== "GC"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 26,
                              attrs: {
                                lazy: true,
                                name: "tabSpecialGoods",
                                label: _vm.$t("SpecialGoods.label")
                              }
                            },
                            [
                              _c("tab-special-goods", {
                                ref: "tabSpecialGoods",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew && _vm.privilege.seBooking.portalState
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 27,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-cross-tenant-se-to-si":
                                    _vm.isCrossTenantSEToSI,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "sop-template-config": _vm.sopTemplateConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 28,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "can-operate-job": _vm.canOperateJob
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.shutOutDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "27",
                visible: _vm.shutOutDialog.visible,
                itle: _vm.$t("Message.Warning"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.shutOutDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "padding-left": "30px"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(_vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "28", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.hasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                      attrs: { no: "29", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.noHasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "30" },
                      on: {
                        click: function($event) {
                          _vm.shutOutDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                no: "31",
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "580px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c("div", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm.businessStatusDialog.visible
        ? _c("business-status-log-dialog", {
            attrs: {
              visible: _vm.businessStatusDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.businessStatusDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.ediStatusLogDialog.visible
        ? _c("edi-status-log-dialog", {
            attrs: {
              visible: _vm.ediStatusLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ediStatusLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.bookingSpaceLogDialog.visible
        ? _c("booking-space-log-dialog", {
            attrs: {
              visible: _vm.bookingSpaceLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.bookingSpaceLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _vm.sendBranchWindow.visible
        ? [
            _vm.sendBranchSelectObject === 2
              ? _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      no: "32",
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.$t("SeaExport.ConsignationSI"),
                      width: "550px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "40px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#000000",
                                "font-size": "14px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.EntrustedRecipient"))
                              )
                            ]
                          )
                        ]),
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("Payment.customerService")
                                    : _vm.$t("FileHistory.operation")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0 ? "csr" : "op"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userId_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "40px",
                          inline: true,
                          "label-position": "left"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.currentOffice.chineseName
                                )
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [_vm._v(_vm._s(_vm.sendBranchWindow.title))]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { value: "consignee", disabled: "" }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: { change: _vm.onConsigneeTargetChange },
                                model: {
                                  value: _vm.sendBranchWindow.consigneeTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeTarget",
                                      $$v
                                    )
                                  },
                                  expression: "sendBranchWindow.consigneeTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ConsignationCompany"
                                    ),
                                    value: "customer"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  value: "consigneeDetail",
                                  disabled: ""
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: {
                                  change: _vm.onConsigneeDetailTargetChange
                                },
                                model: {
                                  value:
                                    _vm.sendBranchWindow.consigneeDetailTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeDetailTarget",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "sendBranchWindow.consigneeDetailTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ShipperDetail"),
                                    value: "shipperDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { "margin-top": "20px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("queryJob.NoteConsigneeCustomerExportImport")
                        )
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { color: "#000000" },
                            on: { change: _vm.onCheckConsigneeDefaultChange },
                            model: {
                              value: _vm.sendBranchWindow.checkConsigneeDefault,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.sendBranchWindow,
                                  "checkConsigneeDefault",
                                  $$v
                                )
                              },
                              expression:
                                "sendBranchWindow.checkConsigneeDefault"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("queryJob.SetAsDefaultExportInfo"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "33", type: "primary" },
                                on: { click: _vm.enterSendHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "34" },
                                on: {
                                  click: function($event) {
                                    _vm.sendBranchWindow.visible = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      no: "32",
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.sendBranchWindow.title,
                      width: "360px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "85px",
                          "label-position": "left"
                        }
                      },
                      [
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("Payment.customerService")
                                    : _vm.$t("FileHistory.operation")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0 ? "csr" : "op"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userId_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm.showdCheckSalesMapping
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("queryJob.SalesMapping")
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "checkSalesMapping" },
                                    model: {
                                      value:
                                        _vm.sendBranchWindow.checkSalesMapping,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.sendBranchWindow,
                                          "checkSalesMapping",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "sendBranchWindow.checkSalesMapping"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.SalesCargoSalesMap")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: { margin: "0 auto", width: "fit-content" },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "33", type: "primary" },
                            on: { click: _vm.enterSendHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { no: "34" },
                            on: {
                              click: function($event) {
                                _vm.sendBranchWindow.visible = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _vm._e(),
      _vm.trustFromWindow.visible
        ? _c("trust-from-window", {
            ref: "trustFromWindow",
            attrs: {
              visible: _vm.trustFromWindow.visible,
              "trust-job": _vm.trustFromWindow.trustJob,
              job: _vm.job,
              "is-cross-tenant-se-to-si": _vm.isCrossTenantSEToSI,
              context: _vm.context,
              "can-operate-job": _vm.canOperateJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.trustFromWindow, "visible", $event)
              },
              refresh: _vm.refresh
            }
          })
        : _vm._e(),
      _vm.crossTenantDialog.visible
        ? _c("cross-tenant-change-history-dialog", {
            attrs: {
              visible: _vm.crossTenantDialog.visible,
              data: _vm.crossTenantDialog.data,
              "has-un-read": _vm.crossTenantDialog.readState,
              "job-uuid": _vm.job.uuid,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.crossTenantDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: "SI",
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationBranchListDialog.visible
        ? _c("cooperation-branch-list", {
            attrs: {
              visible: _vm.cooperationBranchListDialog.visible,
              "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
              job: _vm.cooperationBranchListDialog.job,
              "order-center-branch":
                _vm.cooperationBranchListDialog.orderCenterBranch
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cooperationBranchListDialog,
                  "visible",
                  $event
                )
              },
              refresh: function(cooperatebranch) {
                _vm.updateJobCooperate(cooperatebranch)
                this$1.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)
              },
              cancel: function() {
                return (_vm.cooperationBranchListDialog.visible = false)
              }
            }
          })
        : _vm._e(),
      _vm.jobApplyDialog.visible
        ? _c("job-apply-dialog", {
            attrs: {
              visible: _vm.jobApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_SubmitJobChargeForApproval"),
              type: "apply",
              "doc-id": _vm.job.uuid,
              "document-config-id": _vm.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.jobApplyDialog.visible = false
              },
              closeAndRefresh: _vm.applyCloseAndRefresh
            }
          })
        : _vm._e(),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.selectedApiCallback
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "error-log": _vm.errorLogDialog.errorLog
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "SI",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "detail"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.refresh
        }
      }),
      _c("data-update-log-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.dataUpdateLogDialog.visible,
          "is-need-refresh": _vm.dataUpdateLogDialog.isNeedRefresh,
          "default-is-expand": _vm.dataUpdateLogDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.dataUpdateLogDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.dataUpdateLogDialogClose
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }